import {Component, HostListener, OnInit, OnDestroy, Input, Output, EventEmitter,ViewEncapsulation} from '@angular/core';
import {HttpClientService} from '../../Services/http-client.service';
import {AppSettings} from '../../app-settings';
import {CartSettings} from '../../cart-settings';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from '../../Services/session.service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
@Component({
  selector: 'app-live-session-purchase-modal',
  templateUrl: './live-session-purchase-modal.component.html',
  styleUrls: ['./live-session-purchase-modal.component.css'],
  animations:[
    trigger('slideInOut', [
      state('in', style({
        height: '*'
      })),
      state('out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px'
      })),
      transition('in => out', animate('500ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ]),
    trigger('liveSessionsPurchaseModalPopInOut', [
      transition(':enter', [
        style({opacity: 0}),
        animate('0.3s', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({opacity: 1}),
        animate('0.3s', style({opacity: 0}))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None,
})
export class LiveSessionPurchaseModalComponent implements OnInit,OnDestroy {
  @Input() showPurchaseModal:any;
  @Output() modalClose = new EventEmitter();

  purchaseModalDataSubscribe: Subscription;
  trialOfferExpiryDateSubscribe: Subscription;
  purchaseModalData: any;
  paymentUrl: any;
  trialOfferExpiryDate: any;
  upgradeURL = AppSettings.restApiUrl + '/api/package/upgrade';
  showCloseButton: boolean = false;
  disabled: boolean =false;
  dateMap: any ={
    '1':'st',
    '2':'nd',
    '3':'rd',
    '21':'st',
    '22':'nd',
    '23':'rd',
    "31":'st'
  };
   showloader: boolean=false;
  loadingCircleURL:string = AppSettings.loadingCircleImageURL;
  showCancelButton: boolean=true;
  showTrialEnableMsg: boolean=false;
  showBuyNowMsg: boolean = false;
  LsTrialMsg: string;
  enrollmsg: string;
  returnMsg: string;
  offerEnabled: boolean=false;
  LsTrialMsgBuyNow='';
  enrollmsgBuyNow='';
  returnMsgBuyNow='';
  //showBuyNowMsgBuyNow='';
  constructor(private httpClientService: HttpClientService, private activatedRoute: ActivatedRoute, private router: Router, private sessionService:SessionService) {
    this.purchaseModalDataSubscribe = this.sessionService.sharedGettingPurchaseModalData.subscribe((data)=>{
      if(data!=undefined) {
        this.purchaseModalData = data;
        if (this.purchaseModalData.modalType == 'm1') {
          this.paymentUrl = CartSettings.verbal_live_session_url_m1;
          this.trialOfferExpiryDateSubscribe = this.sessionService.sharedTirialOfferExpiryDate.subscribe((date) => {
            //date = 1597035855000;
            if (date != null) {
              var expiryDate = new Date(date);
              var day = expiryDate.getDate();
              var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
              var currentMonth = months[expiryDate.getMonth()];
              var year = expiryDate.getFullYear();
              var power = this.dateMap[day] ? this.dateMap[day] : 'th';
              this.trialOfferExpiryDate = day + power + ' ' + currentMonth + ' ' + year;
            }
          });
        } else if (this.purchaseModalData.modalType == 'm2') {
          this.paymentUrl = CartSettings.verbal_live_session_url_m2;
        } else if (this.purchaseModalData.modalType == 'm3') {
          this.paymentUrl = CartSettings.verbal_live_session_url_m3;
        }
      }
    });
  }
  ngOnInit()
  {
    this.showCancelButton =true;
    this.showTrialEnableMsg = false;
    this.showBuyNowMsg = false;
  }


  ngOnDestroy()
  {

  }
  ngOnChanges() {
  }

  cancelButtonClick() {
    this.showBuyNowMsg = false;
    if(this.purchaseModalData.modalType == 'm1')
    {
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + '/api/verbal-live-session/trial/user/TRIAL_DECLINED',headers)
        .subscribe(
          (data) => {
           // window.location.href = this.paymentUrl;
          }
        );
    }
    this.showCloseButton = true;
    this.disabled = true;
  }

  closePurchaseModal() {
    if(this.offerEnabled == true){
      window.location.reload();
    }
    this.showPurchaseModal = false;
    this.modalClose.emit(this.showPurchaseModal);
  }

  takeToPaymentPage() {
    if(this.purchaseModalData.modalType == 'm1')
    {
      this.disabled = true;
      this.showCancelButton = false;
      this.showloader = true;
      // setTimeout(()=>{
      //
      // }, 1500);
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + '/api/user/subscribe/trial-live-session-360',headers)
        .subscribe(
          (data) => {

            if(data==true){
              this.offerEnabled = true;
              this.LsTrialMsg = 'You are all set!';
              this.enrollmsg = 'You are now subscribed to LS 360.';
              this.returnMsg = 'Please use the button below to return to the course';
            }
          else {
            this.offerEnabled = false;
              this.LsTrialMsg = 'Sorry, we were unable to complete your request.<div class="textLeft">Please try again later.</div>';
              this.enrollmsg = '';
              this.returnMsg = '';
            }
            this.showloader = false;
            this.showTrialEnableMsg = true;
          }
        );
    }
    else {
     // window.location.href = this.paymentUrl;
      this.LsTrialMsgBuyNow = '<p class="color_red">Live Sessions are currently <b>unavailable</b> for purchase.</p> ';
      this.enrollmsgBuyNow = '<p class="color_red">New batches will start in <b>February 2021.</b></p>';
      this.returnMsgBuyNow = '<p class="color_red"><span>For more details, please email</span> <span class="col-blue"><u>support@e-gmat.com</u></span>.</p>';
      this.showBuyNowMsg = true;

    }
  }
}
